module.exports = __webpack_public_path__ + "static/media/Logo_LTN.db3ed8ab.jpg";